import { collection, getDocs, query, where } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";

const isDuplicatedPhone = async (authProviderPhone) => {
  /**
   * input:
   *  authProvider: email | phone
   * output: bool
   * description: checks if phone number exists
   */

  try {
    const invitedAgentsRef = await collection(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "agents"
    );
    const q = query(
      invitedAgentsRef,
      where("number", "==", authProviderPhone),
      where("is_deleted", "==", false)
    );
    const agentSnapshot = await getDocs(q);

    const businessOwnersRef = collection(db, "users");
    const q2 = query(
      businessOwnersRef,
      //where("role","==","admin"),
      where("phoneNumber", "==", authProviderPhone)
    );
    const businessSnapshot = await getDocs(q2);
    return agentSnapshot.docs.length === 0
      ? businessSnapshot.docs.length === 0
        ? false
        : true
      : true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default isDuplicatedPhone;
